export default "__VITE_ASSET__e288ee9b__"